<template>
  <v-col :cols="isLabelVisible ? 8 : 12" class="pa-0">
    <v-row no-gutters>
      <v-col v-if="isLabelVisible" cols="4" class="pa-0">
        <v-subheader style="height: auto; min-height: 48px">
          <span>
            {{ $i18n.t('offer.attributes.localization.addUsableArea') }}
          </span>
        </v-subheader>
      </v-col>
      <v-col :cols="isLabelVisible ? 8 : 12" class="pa-0">
        <v-row dense no-gutters>
          <v-col :cols="isLabelVisible ? 9 : 10">
            <v-select :readonly="!canEdit" v-model="selectedType" :items="filteredTypes" outlined>
              <template #item="{ item }">
                {{ $i18n.t(`default.${item}`) }}
              </template>
              <template #selection="{ item }">
                {{ $i18n.t(`default.${item}`) }}
              </template>
            </v-select>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="pa-2">
            <v-btn
              fab
              :dark="selectedType ? true : false"
              :title="$i18n.t('offer.attributes.localization.addUsableArea')"
              small
              color="primary"
              class="mr-1"
              @click="addType"
              :disabled="!selectedType"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters v-for="(val, key) in value" :key="key">
      <v-col cols="4" class="pa-0">
        <v-subheader style="height: auto; min-height: 48px">
          <span>{{ $i18n.t(`default.${key}`) }}</span>
        </v-subheader>
      </v-col>
      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model.number="value[key]"
          type="number"
          :step="0.00001"
          :label="label"
          @keydown="isNumber"
          @change="validateValue($event, key)"
          :readonly="!canEdit"
          outlined
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="pa-2">
        <v-btn
          dark
          fab
          :title="$i18n.t('offer.attributes.localization.deleteUsableArea')"
          small
          color="danger"
          class="mr-1"
          @click="deleteType(key)"
        >
          <v-icon dark>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    value: {
      required: true
    }
  },
  data: () => ({
    types: ['residental', 'office', 'retail', 'industrial'],
    selectedType: ''
  }),
  computed: {
    filteredTypes() {
      return this.types.filter(t => !Object.keys(this.value || {}).includes(t));
    },
    label() {
      return new DOMParser().parseFromString('m&sup2', 'text/html').body.textContent;
    }
  },
  methods: {
    addType() {
      if (this.selectedType) {
        this.$set(this.value, this.selectedType, 0);
        this.selectedType = '';
      }
    },
    deleteType(key) {
      this.$delete(this.value, key);
    },
    validateValue(value, key) {
      if (!value) {
        this.$set(this.value, key, 0);
      }
    }
  },
  created() {
    if (!this.value) {
      this.$emit('input', {});
    }
  }
};
</script>